import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaShieldAlt, FaUserSecret, FaDatabase, FaCookieBite } from 'react-icons/fa';
import './Privacy.css';

const Privacy = () => {
  return (
    <div className="privacy">
      {/* Hero Section */}
      <section className="privacy-hero">
        <div className="container">
          <motion.div 
            className="privacy-hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Link to="/" className="back-link">
              <FaArrowLeft />
              Volver al inicio
            </Link>
            <h1>Política de Privacidad</h1>
            <p className="subtitle">
              Tu privacidad es importante para mi. Esta política describe cómo recopilo, 
              utilizo y protejo tu información personal.
            </p>
            <div className="last-updated">
              <strong>Última actualización:</strong> {new Date().toLocaleDateString('es-ES')}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Content Section */}
      <section className="privacy-content section">
        <div className="container">
          <div className="privacy-sections">
            
            {/* Responsable del tratamiento */}
            <motion.div 
              className="privacy-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="section-icon">
                <FaShieldAlt />
              </div>
              <h2>Responsable del Tratamiento</h2>
              <p>
                Los datos personales que se proporcionen serán tratados por Javier Muñoz Velasco, 
                con Número de Colegiado: 017693, como responsable del tratamiento de tus datos personales.
              </p>
              <p>
                <strong>Email:</strong> javier.m.v.2001@gmail.com<br />
                <strong>Teléfono:</strong> 654 38 49 37
              </p>
            </motion.div>

            {/* Finalidad del tratamiento */}
            <motion.div 
              className="privacy-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <div className="section-icon">
                <FaUserSecret />
              </div>
              <h2>Finalidad del Tratamiento</h2>
              <p>Tus datos personales serán utilizados para las siguientes finalidades:</p>
              <ul>
                <li>Gestionar las citas y servicios de fisioterapia</li>
                <li>Proporcionar atención médica y tratamiento personalizado</li>
                <li>Mantener la historia clínica y seguimiento del paciente</li>
                <li>Enviar comunicaciones relacionadas con tu tratamiento</li>
                <li>Cumplir con las obligaciones legales y sanitarias</li>
              </ul>
            </motion.div>

            {/* Legitimación */}
            <motion.div 
              className="privacy-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <div className="section-icon">
                <FaDatabase />
              </div>
              <h2>Legitimación</h2>
              <p>El tratamiento de tus datos está basado en:</p>
              <ul>
                <li><strong>Consentimiento:</strong> Para el tratamiento de tus datos personales</li>
                <li><strong>Ejecución de contrato:</strong> Para la prestación de servicios de fisioterapia</li>
                <li><strong>Interés legítimo:</strong> Para mejorar los servicios</li>
                <li><strong>Obligación legal:</strong> Para cumplir con la normativa sanitaria</li>
              </ul>
            </motion.div>

            {/* Conservación de datos */}
            <motion.div 
              className="privacy-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              viewport={{ once: true }}
            >
              <div className="section-icon">
                <FaCookieBite />
              </div>
              <h2>Conservación de Datos</h2>
              <p>Tus datos personales se conservarán:</p>
              <ul>
                <li><strong>Historia clínica:</strong> Durante el tiempo establecido por la normativa sanitaria</li>
                <li><strong>Datos de contacto:</strong> Mientras mantengamos una relación comercial</li>
                <li><strong>Datos de facturación:</strong> Durante el tiempo necesario para cumplir con las obligaciones fiscales</li>
              </ul>
            </motion.div>

            {/* Destinatarios */}
            <motion.div 
              className="privacy-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <h2>Destinatarios</h2>
              <p>Tus datos no serán cedidos a terceros, salvo:</p>
              <ul>
                <li>Cuando exista una obligación legal</li>
                <li>Con tu consentimiento expreso</li>
                <li>Para la prestación de servicios por parte de proveedores externos (sistemas informáticos, etc.)</li>
              </ul>
            </motion.div>

            {/* Derechos */}
            <motion.div 
              className="privacy-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              viewport={{ once: true }}
            >
              <h2>Tus Derechos</h2>
              <p>Puedes ejercer los siguientes derechos:</p>
              <ul>
                <li><strong>Acceso:</strong> Conocer qué datos tengo sobre ti</li>
                <li><strong>Rectificación:</strong> Corregir datos inexactos</li>
                <li><strong>Supresión:</strong> Eliminar tus datos (con limitaciones legales)</li>
                <li><strong>Limitación:</strong> Restringir el tratamiento</li>
                <li><strong>Portabilidad:</strong> Recibir tus datos en formato estructurado</li>
                <li><strong>Oposición:</strong> Oponerte al tratamiento</li>
              </ul>
              <p>
                Para ejercer estos derechos, puedes contactarme.
              </p>
            </motion.div>

            {/* Cookies */}
            <motion.div 
              className="privacy-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              viewport={{ once: true }}
            >
              <h2>Cookies</h2>
              <p>
                Esta web utiliza cookies técnicas necesarias para su funcionamiento. 
                No utilizo cookies de seguimiento ni publicitarias.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="privacy-cta section">
        <div className="container">
          <motion.div 
            className="cta-content"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2>¿Tienes alguna pregunta sobre privacidad?</h2>
            <p>
              Estoy aquí para ayudarte. Si tienes alguna duda sobre cómo trato tus datos, 
              no dudes en contactarme.
            </p>
            <div className="cta-buttons">
              <Link to="/contacto" className="btn btn-primary">
                Contactar
              </Link>
              <Link to="/" className="btn btn-secondary">
                Volver al inicio
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Privacy; 